import './Badge.css'
import type { BadgeProps } from './Badge.types'

export function Badge({ color, children }: BadgeProps) {
  return <span className={`badge badge-${color}`}>{children}</span>
}
